<template lang="pug">
  validation-observer(ref="obs" slim)
    app-expansion-panel
      app-expansion-panel-header(outlined)
        .d-flex.align-center
          v-list-item-icon.my-2
            v-icon(:color="state.color") {{ state.icon }}
          v-row
            v-list-item-title
              span {{ nomination.name }}
            v-list-item-subtitle.mt-2
              span(:class="[`${state.color}--text`]") {{ state.name }}

        template(v-slot:actions)
          v-icon(small color="redesignBlack") $ichevron-down
      app-expansion-panel-content(eager)
        div.pa-4
          additional-fields-form(
            v-model="formData"
            :event="event"
            :fields="currentFields"
            :nomination="nomination"
            @hook:mounted="obs = $refs.obs"
          )
</template>

<script>
import AppExpansionPanel from '@/components/user-redesign/expansion-panels/AppExpansionPanel.vue';
import AppExpansionPanelHeader from '@/components/user-redesign/expansion-panels/AppExpansionPanelHeader.vue';
import AppExpansionPanelContent from '@/components/user-redesign/expansion-panels/AppExpansionPanelContent.vue';
import AdditionalFieldsForm from '@/modules/UserEventLanding/components/forms/AdditionalFieldsForm.vue';

const STATES = {
  filled: 0,
  unfilled: 1,
  error: 2,
};

const STATES_DATA = {
  [STATES.filled]: {
    icon: '$icheck-outline-circle',
    color: 'redesignSuccess',
    name: 'Заполнено',
  },
  [STATES.unfilled]: {
    icon: '$iclock-outline',
    color: 'warning',
    name: 'Не заполнено',
  },
  [STATES.error]: {
    icon: '$ialert',
    color: 'redesignError',
    name: 'Есть ошибки',
  },
};

export default {
  components: {
    AppExpansionPanel,
    AdditionalFieldsForm,
    AppExpansionPanelHeader,
    AppExpansionPanelContent,
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    nomination: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      obs: null,
      formData: this.value,
    };
  },
  computed: {
    // TODO: поправить в будущем
    // Сделано для того, чтобы выдавать правильные индексы
    // Может, если договорится с бэкендом, о другом формате отправки данных, то будет лучше
    currentFields() {
      return this.fields.reduce((acc, item, idx) => {
        if (item.nomination_id === this.nomination.id) {
          return { ...acc, [idx]: item };
        }
        return acc;
      }, {});
    },
    state() {
      // TODO: придумать что-то по лучше, чем наблюдать за флагами обсервера
      const { obs, currentFields } = this;
      const unfilled = Object.values(currentFields).some((i) => i.is_required);
      return STATES_DATA[
        +Boolean(unfilled && obs?.flags?.invalid)
        + +Boolean(obs?.flags?.failed)
      ];
    },
  },
  watch: {
    value(val) {
      this.formData = val;
    },
    formData(val) {
      this.$emit('input', val);
    },
  },
};
</script>
